//import "../css/sakura.css";
import "./assets/css/consultas_sae.css";


import { Form } from "./ConsultaForm";

import TemasConsultaRepository from "./services/TemasConsultaRepository";

let temasConsultaRepository = new TemasConsultaRepository();

document.addEventListener("DOMContentLoaded", () => {

  aplicaComponentesJDA();
  new Form("consulta_form", temasConsultaRepository, calculaReabrirConsulta());

  window.addEventListener("load", (event) => {
    document.getElementsByTagName("html")[0].style.visibility = "visible";
  });

});

function calculaReabrirConsulta(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const reabrir = urlParams.get('reabrir');
    return reabrir;
}



function aplicaComponentesJDA() {

    cargaRecursosJDA();
    cargaCabeceraJDA();
    cargaPieJDA();
  }


//TODO: Lo ideal sería que diariamente, con algún proceso externo, se compruebe si hay algún cambio en estos ficheros 
//con respecto a los que expone la Junta, pero no traer los cambios directamente, sino probarlos. Es decir, que avise
//y cree una PULL Request, por ejemplo.

function cargaRecursosJDA() {
  try {
      
    const div = document.getElementById("recursos");

    const promesaResponse =  fetch('data/recursosJDA.html');
    
    const promesaTexto =  promesaResponse.then(respuesta => respuesta.text());

    promesaTexto.then(texto => div.innerHTML = texto);


  } catch (error) {

    console.log('No se han podido cargar los recursos corporativos: ', error);
  }
}

function cargaCabeceraJDA() {
  try {
      
    const div = document.getElementById("cabeceraJunta");

    const promesaResponse =  fetch('data/cabeceraJDA.html');
   // const promesaResponse =  fetch('https://www.juntadeandalucia.es/exportacion/cabecera/organismos/sae.html', {mode:'no-cors'});

    const promesaTexto =  promesaResponse.then(respuesta => respuesta.text());

    promesaTexto.then(texto => div.innerHTML = texto);


  } catch (error) {

    console.log('No se ha podido cargar la cabecera: ', error);
  }
}



function cargaPieJDA() {
  try {
      
    const div = document.getElementById("footer");

    const promesaResponse =  fetch('data/pieJDA.html');
    
    const promesaTexto =  promesaResponse.then(respuesta => respuesta.text());

    promesaTexto.then(texto => div.innerHTML = texto);


  } catch (error) {

    console.log('No se ha podido cargar el pie: ', error);
  }
}

